import { takeLatest, call, put, select } from 'redux-saga/effects';
import { checkEnvironment } from 'ui-common/src/lib/utils';
import { generateQueryParam } from 'ui-common/src/utils/apiUtils';
import { showNotificationModal } from 'ui-common/src/utils/Loading-actions';
import { isEqual } from 'lodash';
import {
  FEATURE_LIST,
  featureListSuccess,
  UPDATE_FEATURE,
  UPDATE_THEME_CONFIG_LIST,
  updateThemeConfigListSuccess,
  updateThemeConfigListFailure,
  DOWNLOAD_ATTACHEMENT,
  UPLOAD_AS_FILE,
  REQUEST_MANAGE_LOGS_LIST,
  requestManageLogsListSuccess,
  requestManageLogsListFailure,
} from './adminHome-actions';
import {
  GET_MESSAGE_LABELS,
  SAVE_MESSAGE_PROP,
  getMessageLabelsSuccess,
  saveMessagePropSuccess,
  getMessageLabels as getMessageLabelsAction,
} from '../views/LabelChangeManagement/actions';
import { getIntl } from '../../../misc/IntlUtil';
import { defaultTheme } from '../views/UIBrandConfiguration/ConfigurationTypes/defaultTheme';

function* getFeatureList() {
  try {
    const { GATEWAY_API_URL } = checkEnvironment();
    let url = null;
    if (window.DEMO_MODE) {
      url = `http://${window.location.hostname}:3100/api/usermssecurityfeatures`;
    } else {
      url = `${GATEWAY_API_URL}/api/userms/security/features`;
    }
    const response = yield call(fetch, url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response.status === 200) {
      const json = yield call([response, response.json]);
      yield put(featureListSuccess(json));
    }
  } catch (err) {
    console.log(err);
  }
}

function* updateFeature(action) {
  const { GATEWAY_API_URL } = checkEnvironment();
  let url = null;
  if (window.DEMO_MODE) {
    url = `http://${window.location.hostname}:3100/api/usermssecurityfeatures/${action.payload.id}`;
  } else {
    url = `${GATEWAY_API_URL}/api/userms/security/features/${action.payload.id}`;
  }
  const response = yield call(fetch, url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(action.payload),
  });
  if (response.status === 200) {
    yield call([response, response.json]);
    yield put({ type: FEATURE_LIST });
  }
}

function* updateThemeConfig(action) {
  const SERVICE_ENDPOINT_IDWMS = checkEnvironment().IDWMS_API_URL;
  const modifiedThemeItems = {};
  Object.keys(action.configThemeObj).reduce((diff, key) => {
    if (!isEqual(defaultTheme[key], action.configThemeObj[key]))
      modifiedThemeItems[key] = action.configThemeObj[key];
    return true;
  }, {});
  try {
    const defaultBody = {
      fileName: 'theme.json',
      folderPath: '/app/usr',
      resourceBody: JSON.stringify(modifiedThemeItems),
    };
    const url = `${SERVICE_ENDPOINT_IDWMS}/res/content`;
    const response = yield call(fetch, url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(defaultBody),
    });
    if (response && response.status === 200) {
      const json = yield call([response, response.json]);
      if (json) {
        yield put(updateThemeConfigListSuccess(json));
        action.handleSuccess();
      }
    }
  } catch {
    yield put(updateThemeConfigListFailure());
  }
}

function* downloadAttachment(action) {
  let response = '';
  try {
    const url = action.urlType;
    if (action.method === 'POST') {
      response = yield call(fetch, url, {
        method: action.method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(action.data),
      });
    } else {
      response = yield call(fetch, url, {
        method: action.method,
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
    if (response.status === 200) {
      response.arrayBuffer().then(function(buffer) {
        const responseUrl = window.URL.createObjectURL(new Blob([buffer]));

        action.handleDownloadResponse(responseUrl, action.fileName);
      });
    }
  } catch (err) {
    console.log(err);
  }
}

function* uploadAsFile(action) {
  try {
    const formData = new FormData();
    formData.append('file', action.fileData);
    formData.append('path', action.path);

    const url = action.urlType;
    const response = yield call(fetch, url, {
      method: 'POST',
      headers: {
        Authorization: `${localStorage.getItem('token_type')} ${localStorage.getItem(
          'access_token'
        )}`,
      },
      body: formData,
    });
    if (response.status === 200) {
      action.handleUploadResponse(action.fileData.name, action.fileData);
    } else {
      action.handleFailureResponse(response);
    }
  } catch (err) {
    action.handleFailureResponse(err);
    console.log(err);
  }
}

function* getMessageLabels(action) {
  const { payload } = action;
  const SERVICE_ENDPOINT_IDWMS = checkEnvironment().IDWMS_API_URL;
  try {
    // let url = `http://localhost:5000/messageProperties`;
    let url = `${SERVICE_ENDPOINT_IDWMS}/messageProperties`;
    let queryParam = {};
    if (payload && payload.reqBodyOptions) {
      queryParam = { ...payload.reqBodyOptions };
    }
    const response = yield call(fetch, `${url}${generateQueryParam(queryParam)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response.status === 200) {
      const json = yield call([response, response.json]);
      if (json) {
        yield put(getMessageLabelsSuccess(json));
      }
    }
  } catch (err) {
    console.log(err);
  }
}

const editedLabels = state => state.adminHome.messageProps.editedLabels;
const selectedLanguages = state => state.adminHome.messageProps.selectedLanguages;

const getLabelSaveSuccessMsg = (intl) => {
  return {
    type: 'SUCCESS',
    title: intl.formatMessage({id: 'MANAGE.LABEL.SAVE.SUCCESS.TITLE'}),
    details: intl.formatMessage({id: 'MANAGE.LABEL.SAVE.SUCCESS.DETAILS'}),
  }
}

const getLabelSaveFailureMsg = (intl) => {
  return {
    type: 'FAILURE',
    title: intl.formatMessage({id: 'MANAGE.LABEL.SAVE.FAILURE.TITLE'}),
    details: intl.formatMessage({id: 'MANAGE.LABEL.SAVE.FAILURE.DETAILS'}),
  }
}

function* updateMessageLabels() {
  const modifiedLabels = yield select(editedLabels);
  const selectedLanguage = yield select(selectedLanguages);
  let modifiedBody = [];
  modifiedLabels.map(item => {
    selectedLanguage.map(language => {
      item.messageValues.map(value => {
        if (language === value.language) {
          modifiedBody[language] = {
            ...modifiedBody[language],
            [item.messageKey]: value.content,
          };
        }
        return true;
      });
      return true;
    });
    return true;
  });
  const payload = Object.assign({}, modifiedBody);

  const SERVICE_ENDPOINT_IDWMS = checkEnvironment().IDWMS_API_URL;
  try {
    // let url = `http://localhost:5000/messageProperties`;
    let url = `${SERVICE_ENDPOINT_IDWMS}/messageProperties`;
    const response = yield call(fetch, url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ i18ndata: payload }),
    });
    if (response && response.status === 204) {
      yield put(saveMessagePropSuccess());
      yield put(showNotificationModal(getLabelSaveSuccessMsg(getIntl())));
    } else {
      yield put(showNotificationModal(getLabelSaveFailureMsg(getIntl())));
    }
  } catch (err) {
    yield put(showNotificationModal(getLabelSaveFailureMsg(getIntl())));
  }
}
function* requestManageLogs(action) {
  const GATEWAY_API_URL = checkEnvironment().GATEWAY_API_URL;
  try {
    const url = `${GATEWAY_API_URL}/api/logms/logsearch`;
    const response = yield call(fetch, url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(action.data),
    });
    if (response && response.status === 200) {
      const json = yield call([response, response.json]);
      if (json) {
        if (json.status === 'OK') {
          yield put(requestManageLogsListSuccess(json.logs));
        } else {
          yield put(requestManageLogsListFailure());
        }
      }
    } else {
      yield put(requestManageLogsListFailure());
    }
  } catch {
    yield put(requestManageLogsListFailure());
  }
}

export default function* adminHomeSaga() {
  yield takeLatest(FEATURE_LIST, getFeatureList);
  yield takeLatest(UPDATE_FEATURE, updateFeature);
  yield takeLatest(UPDATE_THEME_CONFIG_LIST, updateThemeConfig);
  yield takeLatest(DOWNLOAD_ATTACHEMENT, downloadAttachment);
  yield takeLatest(UPLOAD_AS_FILE, uploadAsFile);
  yield takeLatest(GET_MESSAGE_LABELS, getMessageLabels);
  yield takeLatest(SAVE_MESSAGE_PROP, updateMessageLabels);
  yield takeLatest(REQUEST_MANAGE_LOGS_LIST, requestManageLogs);
}
